import React from 'react';
import Modal from './Modal';
import Button from './Button';

/**
 * ConfirmModal 컴포넌트
 * window.confirm / 즉시 비가역 삭제를 대체하는 스타일·접근성 갖춘 확인 다이얼로그.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {Function} props.onClose - 취소/닫기
 * @param {Function} props.onConfirm - 확인
 * @param {string} props.title
 * @param {React.ReactNode} props.message - 본문 메시지
 * @param {string} props.confirmlabel
 * @param {string} props.cancelLabel
 * @param {'primary'|'danger'} props.confirmVariant - 확인 버튼 스타일
 * @param {boolean} props.loading - 처리 중 상태 (버튼 비활성화)
 */
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = '확인',
  message,
  confirmLabel = '확인',
  cancelLabel = '취소',
  confirmVariant = 'primary',
  loading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm} disabled={loading}>
            {loading ? '처리 중...' : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm leading-relaxed text-accent-800">{message}</p>
    </Modal>
  );
};

export default ConfirmModal;
